import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class OverseasEventParent extends List {
  constructor(obj) {
    super(OverseasEvent, obj)
  }
}

export class OverseasEvent {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.fromDate = obj?.fromDate || null
    this.toDate = obj?.toDate || null
    this.stayPlace = obj?.stayPlace || null
    this.organizationName = obj?.organizationName || null
    this.participationKind = obj?.participationKind || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      fromDate: this.fromDate,
      toDate: this.toDate,
      stayPlace: this.stayPlace,
      organizationName: this.organizationName,
      participationKind: this.participationKind
    }
  }
}
